<template>
    <div class="list-item-wrap">
        <div class="w100" v-if="isHead">
            <span 
                class="text head" 
                v-for="(item, index) in data"
                :key="index">{{item}}</span>
        </div>
        <div class="w100" v-else-if="home">
            <span class="text" :title="data.name">{{data.name}}</span>
            <span class="text" :title="data.address">{{data.address}}</span>
            <span class="text" :title="data.phone">{{data.phone}}</span>
            <span class="text" :title="getPrice">{{getPrice}}</span>
            <span class="text" :title="getSended">{{getSended || 0}}t</span>
            <span class="text">
                <span class="btn" @click="handleClick('edit')">详情</span>
                <span class="btn" style="margin-left: 10px;" @click="handleClick('del')">删除</span>
            </span>
        </div>
        <div class="w100" v-else>
            <span class="text" :title="data.date">{{data.date}}</span>
            <!-- <span class="text" :title="data.singlePrice">{{data.singlePrice}}</span> -->
            <span class="text"><input class="w100" type="text" v-show="isEdit" 
                v-model.number="editInfo.singlePrice"></span>
            <!-- <span class="text" :title="data.amount">{{data.amount}}</span> -->
            <span class="text"><input class="w100" type="text" v-show="isEdit" 
                v-model.number="editInfo.amount"></span>
            <span class="text" :title="Number(data.singlePrice) * Number(data.amount)">
                {{Number(data.singlePrice) * Number(data.amount)}}</span>
            <!-- <span class="text" :title="data.hasPay">{{data.hasPay}}</span> -->
            <span class="text">
                <span class="radio">
                    <span>
                        <label :for="`yes${id}`">是：</label>
                        <input :id="`yes${id}`" class="w100" :name="`input${id}`" type="radio" v-show="isEdit" 
                        @click="editInfo.hasPay = 1" :checked="editInfo.hasPay">
                    </span>
                    <span>
                        <label :for="`no${id}`">否：</label>
                        <input :id="`no${id}`" class="w100" :name="`input${id}`" type="radio" v-show="isEdit" 
                        @click="editInfo.hasPay = 0" :checked="!editInfo.hasPay">
                    </span>
                </span>
            </span>
            <span class="text">
                <span class="btn" @click="handleClick('del')">删除</span>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ListItem',
    props: ['data', 'isHead', 'home', 'id'],
    data: function () {
        return {
            isEdit: true,
            editInfo: {
                singlePrice: '',
                amount: '',
                hasPay: 0
            }
        }
    },
    watch: {
        data: {
            handler(val) {
                this.editInfo = val;
            },
            deep: true,
            immediate: true
        },
        editInfo: {
            handler(val) {
                let data = this.data;
                this.$emit('updateListItem', data);
            }
        }
    },
    computed: {
        getPrice() {
            const data = this.data;
            if(data.list) {
                let total = 0;
                data.list.map(item => {
                    if(item.hasPay == 1) {
                        total += item.singlePrice * item.amount;
                    }
                });
                return total;
            }
            return 0;
        },
        getSended() {
            const data = this.data;
            if(data.list) {
                let total = 0;
                data.list.map(item => {
                    if(item.hasPay == 1) {
                        total += item.amount;
                    }
                });
                return total;
            }
            return 0;
        }
    },
    methods: {
        handleClick(type) {
            this.$emit('onClick', type);
        }
    }
}
</script>

<style scoped>
.head {
    background: #f9f9f9;
}
.list-item-wrap {
    width: 100%;
    text-align: left;
    border-top: 1px solid #eee;
    min-height: 40px;
}
.list-item-wrap .w100 {
    display: flex;
    flex-direction: row;
}
input {
    margin: 0;
    margin-top: 4px;
}
.list-item-wrap .text {
    line-height: 40px;
    text-align: center;
    flex: auto;
    width: 100px;
    padding: 0 10px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    border-left: 1px solid #eee;
}
.list-item-wrap:last-child {
    border-bottom: 1px solid #eee;
}
.list-item-wrap .radio {
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}
.list-item-wrap .radio input {
    width: 15px;
    margin-top: 0;
    height: 15px;
}
.list-item-wrap .radio span {
    display: inline-flex;
    align-items: center;
}
</style>